import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { acceptedCategory } from 'vanilla-cookieconsent';

const StyledBox = styled('div')(({ theme }) => ({
  alignSelf: 'center',
  width: '100%',
  position: 'relative',
  overflow: 'hidden',
  paddingBottom: '56.25%',
  marginTop: theme.spacing(8),
  borderRadius: theme.shape.borderRadius,
  outline: '0px solid',
  outlineColor: 'hsla(220, 25%, 80%, 0.2)',
  border: '1px solid',
  borderColor: theme.palette.grey[200],
  boxShadow: '0 0 12px 8px hsla(268, 100%, 90%, 0.2)',
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(10),
  },
  ...theme.applyStyles('dark', {
    boxShadow: '0 0 12px 8px hsla(268, 100%, 25%, 0.2)',
    outlineColor: 'hsla(268, 20%, 42%, 0.1)',
    borderColor: theme.palette.grey[700],
  }),
}));

const VideoIframe = styled('iframe')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  border: 'none',
});

export default function Hero() {
  return (
    <Box
      id="hero"
      sx={(theme) => ({
        width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundImage:
          'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(268, 100%, 90%), transparent)',
        ...theme.applyStyles('dark', {
          backgroundImage:
            'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(268, 100%, 16%), transparent)',
        }),
      })}
    >
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 14, sm: 20 },
          pb: { xs: 8, sm: 12 },
        }}
      >
        <Stack
          spacing={2}
          useFlexGap
          sx={{ alignItems: 'center', width: { xs: '100%', sm: '70%' } }}
        >
          <Typography
            variant="h1"
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: 'center',
              fontSize: 'clamp(3rem, 10vw, 3.5rem)',
            }}
          >
            Meet&nbsp;
            <Typography
              component="span"
              variant="h1"
              sx={(theme) => ({
                fontSize: 'inherit',
                color: 'primary.main',
                ...theme.applyStyles('dark', {
                  color: 'primary.light',
                }),
              })}
            >
              MagicDefocus2
            </Typography>
          </Typography>
          <Typography
            sx={{
              textAlign: 'center',
              color: 'text.secondary',
              width: { sm: '100%', md: '80%' },
            }}
          >
            Fast, easy and accurate. Defocus as it should be.
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            sx={{ minWidth: 'fit-content' }}
            href="#trial"
          >
            Try it out
          </Button>
        </Stack>
        <StyledBox id="video">
          {acceptedCategory('functional') && (
            <VideoIframe
              src="https://player.vimeo.com/video/975527746?h=1a3a60fbe9"
              allow="autoplay; fullscreen"
              allowFullScreen
            />
          )}
          {!acceptedCategory('functional') && (
            <center>
              <br></br>
              Please enable cookies for the video to show.
            </center>
          )}
        </StyledBox>
      </Container>
    </Box >
  );
}
